import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { ValidationStatusComponent } from '../../components/ValidationStatusComponent';

export const StatementWarningPageRightBlock: React.FC<any> = observer(
	() =>
	{
		return (
			<div className="form-steps">
				<ValidationStatusComponent />
			</div>
		);
	}
)
